module.exports = __webpack_public_path__ + "img/running.61be6304.gif";